import { Component, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { CheckoutResponse } from '../../core/models/checkout.model';
import { CheckoutService } from '../../core/services/checkout.service';
import { Volunteer } from '../../core/models/volunteer.model';
import { VolunteerService } from '../../core/services/volunteer.service';
import { QrCodeScannerComponent } from './qr-code-scanner/qr-code-scanner.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checkout-manager',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    QrCodeScannerComponent
  ],
  templateUrl: './checkout-manager.component.html',
  styleUrls: ['./checkout-manager.component.scss']
})
export class CheckoutManagerComponent {


  volunteer: Volunteer | null = null;
  error: string | null = null;
  success: string | null = null;
  isLoading: boolean = false;
  cpfForm: FormGroup;
  showQrScanner: boolean = false;
  description: string = '';

  constructor(
    private fb: FormBuilder,
    private checkoutService: CheckoutService,
    private volunteerService: VolunteerService,
    private router: Router
  ) {
    this.cpfForm = this.fb.group({
      cpf: ['', [Validators.required, Validators.minLength(11)]]
    });
  }

  onSearch() {
    if (this.cpfForm.valid) {
      this.isLoading = true;
      this.error = null;
      this.volunteer = null;
      this.volunteerService.getVolunteerByCpf(this.cpfForm.value.cpf).subscribe({
        next: (data: Volunteer) => {
          this.volunteer = data;
          this.isLoading = false;
        },
        error: () => {
          this.error = 'Erro ao buscar voluntário. Por favor, verifique o CPF e tente novamente.';
          this.isLoading = false;
        }
      });
    }
  }

  onOpenQrScanner() {
    this.showQrScanner = true;
    this.error = null;
    this.success = null;
  }

  onCloseQrScanner() {
    this.showQrScanner = false;
  }

  onQrCodeScanned(result: string) {
    console.log('QR Code scanned:', result);
    this.showQrScanner = false;
    this.isLoading = true;
    this.error = null;
    this.volunteer = null;
    this.checkoutService.getStaffById(result).subscribe({
      next: (data: Volunteer) => {
        setTimeout(() => {
          this.volunteer = data;
          this.isLoading = false;
          // this.cdr.detectChanges();
        });
      },
      error: () => {
        setTimeout(() => {
          this.error = 'Erro ao buscar voluntário. Por favor, verifique o CPF e tente novamente.';
          this.isLoading = false;
          // this.cdr.detectChanges();
        });
      }
    });
    // if (result) {
    //   this.performCheckout(result);
    // }
  }

  performCheckout(memberId: string) {
    if (!memberId) return;
    this.isLoading = true;
    this.error = null;
    this.success = null;
    const payload = {
      memberId,
      description: this.description.trim(),
    };
    this.checkoutService.checkoutStaff(payload).subscribe({
      next: (response) => {
        this.success = 'Checkout realizado com sucesso!';
        this.isLoading = false;
        this.resetForm();
      },
      error: (error: any) => {
        this.error = error.error?.message || 'Erro ao realizar checkout.';
        this.isLoading = false;
        this.resetForm();
      }
    });
  }

  performDesertion(memberId: string) {
    if (!memberId) return;
    this.isLoading = true;
    this.error = null;
    this.success = null;
    const payload = {
      memberId,
      description: this.description.trim(),
    };
    this.checkoutService.desertionStaff(payload).subscribe({
      next: (response) => {
        this.success = 'Deserção realizada com sucesso!';
        this.isLoading = false;
        this.resetForm();
      },
      error: (error: any) => {
        this.error = error.error?.message || 'Erro ao realizar deserção.';
        this.isLoading = false;
        this.resetForm();
      }
    });
  }

  performChangeJob(volunteerId: string, eventId?: string) {
    // Navega para o relocate-manager passando os parâmetros necessários
    this.router.navigate(['/relocate-manager'], {
      queryParams: {
        volunteerId,
        eventId: eventId || ''
      }
    });
  }

  // Limpa mensagem de sucesso ao digitar novo CPF
  onCpfInput() {
    if (this.success) {
      this.success = null;
    }
  }



  getWhatsappLink(telefone: string | undefined | null): string {
    if (!telefone) return '';
    const numero = telefone.replace(/\D/g, '');
    // Considera válido apenas se tiver pelo menos 10 dígitos
    if (numero.length < 10) return '';
    return `https://wa.me/55${numero}`;
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR');
  }

  resetForm() {
    this.cpfForm.reset();
    this.volunteer = null;
    setTimeout(() => {
      this.error = null;
      this.success = null;
    }, 3500);
  }
}
